import React, {useEffect, useState} from 'react';
import {Box, Button, Grid, IconButton, ListItem, Tooltip, Typography} from '@deere/fuel-react';
import {toCapitalize} from "../shared/utils";
import {ADMIN, CHANGE_COMMENT_VISIBLE, EDIT_COMMENT, SBM, SUPPLIER} from "../shared/Constants";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

export const RatingCommentDisplay = ({
                                         criteriaComment,
                                         suppliers,
                                         isActionsAllowed,
                                         isDivider,
                                         onCommentsAction,
                                         loggedInUser,
                                         type,
                                         categoryId,
                                         isSupplierMimic
                                     }) => {
    const [roleName, setRoleName] = useState("")
    const [isEdit, setIsEdit] = useState(false)

    useEffect(() => {
            if (criteriaComment.role === "SBM")
                setRoleName(SBM)
            else if (criteriaComment.role === "ADMIN")
                setRoleName(ADMIN)
            else if (criteriaComment.role === "SUPPLIER")
                setRoleName(SUPPLIER)
            else
                setRoleName("")
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [criteriaComment]);

    useEffect(() => {
            if (loggedInUser && loggedInUser.toUpperCase() === criteriaComment.user.racfID)
                setIsEdit(true)
            else
                setIsEdit(false)
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [loggedInUser, criteriaComment]);

    return (
        <>

            {((isActionsAllowed && !isSupplierMimic) || ((!isActionsAllowed || isSupplierMimic) && criteriaComment.isCommentVisible)) &&
            <ListItem divider={suppliers.length === 1 || isDivider} style={{padding: '.5rem 0rem'}} key={"-5"}>
                <Grid container alignItems="center">
                    {isActionsAllowed && !isSupplierMimic &&
                    <Grid item xs={1} style={{
                        maxWidth: '5%'
                    }}>
                        {criteriaComment.role !== "SUPPLIER" &&
                        <Tooltip
                            title={CHANGE_COMMENT_VISIBLE}
                            placement="bottom-start"
                        >
                            {criteriaComment.isCommentVisible ?
                                <IconButton aria-label="visibility" onClick={() => {
                                    if (type === "categoryComments")
                                        onCommentsAction(false, categoryId, "update-visibility", criteriaComment.id)
                                    else
                                        onCommentsAction(false, criteriaComment.id, "update-visibility")
                                }}>
                                    <VisibilityIcon style={{color: "#367c2b"}}/>
                                </IconButton>
                                :
                                <IconButton aria-label="visibility" onClick={() => {
                                    if (type === "categoryComments")
                                        onCommentsAction(true, categoryId, "update-visibility", criteriaComment.id)
                                    else
                                        onCommentsAction(true, criteriaComment.id, "update-visibility")
                                }}>
                                    <VisibilityOffIcon style={{color: "#ccc"}}/>
                                </IconButton>
                            }
                        </Tooltip>
                        }
                    </Grid>
                    }
                    <Grid item xs={isActionsAllowed && !isSupplierMimic ? 11 : 12}
                          style={(isActionsAllowed && !isSupplierMimic && suppliers.length === 1) ? {
                              maxWidth: '95%',
                              flexBasis: '95%'
                          } : (!isActionsAllowed && suppliers.length === 1) ? {paddingLeft: '2rem'} :
                              (isActionsAllowed && !isSupplierMimic && suppliers.length > 1) ? {
                                  paddingRight: ".5rem",
                                  maxWidth: '95%',
                                  flexBasis: '95%'
                              } : {
                                  paddingRight: ".5rem",
                                  paddingLeft: "2rem"
                              }}>
                        <Grid container alignItems="center">
                            <Grid item xs={8}>
                                <Box display="flex"
                                     justifyContent="flex-start">
                                    <Typography color="primary">
                                        {criteriaComment.comment}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                {type === "categoryComments" && isEdit &&
                                <Box display="flex"
                                     justifyContent="flex-end">
                                    <Button variant="text" style={{padding: 0}} onClick={() => {
                                        onCommentsAction("", criteriaComment.id, "edit-click")
                                    }}>
                                        {EDIT_COMMENT}
                                    </Button>
                                </Box>
                                }
                                {type !== "categoryComments" && isActionsAllowed && isEdit && !isSupplierMimic &&
                                <Box display="flex"
                                     justifyContent="flex-end">
                                    <Button variant="text" style={{padding: 0}} onClick={() => {
                                        onCommentsAction("", criteriaComment.id, "edit-click")
                                    }}>
                                        {EDIT_COMMENT}
                                    </Button>
                                </Box>
                                }
                            </Grid>
                            <Grid item xs={8}>
                                <Box display="flex" justifyContent="flex-start">
                                    <Typography color="secondary" size="sm">
                                        {`${toCapitalize(criteriaComment.user.lastName)}, ${toCapitalize(criteriaComment.user.firstName)}`}
                                        {roleName && (` | ${roleName}`)}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box display="flex" justifyContent="flex-end">
                                    <Typography color="secondary" size="sm">
                                        {criteriaComment.submittedDate}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItem>
            }
        </>
    )
}
